import { createFileRoute } from "@tanstack/react-router";
import { Notifications } from "../../pages/Notifications";

export const Route = createFileRoute("/helpdesk/notifications")({
  component: Notifications,
});
